import { useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import type { Dispatch } from '@swf/core/store';
import { select } from '@swf/core/store';

const useCloseOnAuth = () => {
  const { modal } = useDispatch<Dispatch>();
  const isAuthenticated = useSelector(select.session.isAuthenticated);
  const mounted = useRef(true);

  useEffect(() => {
    // Close logout modal when authenticated after first mount
    if (isAuthenticated && !mounted.current) {
      modal.close('/sports/logged-out');
    }

    mounted.current = false;
  }, [isAuthenticated, modal]);
};

export default useCloseOnAuth;
